import { render, staticRenderFns } from "./account-dialog.vue?vue&type=template&id=983f163a&scoped=true&"
import script from "./account-dialog.vue?vue&type=script&lang=ts&"
export * from "./account-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./account-dialog.vue?vue&type=style&index=0&id=983f163a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f163a",
  null
  
)

export default component.exports